const SignInHeaderMap = new Map();

SignInHeaderMap.set(
  "_default",
  "https://merchant.cashfree.com/merchants/login",
);
SignInHeaderMap.set(
  "partner-program",
  "https://partner.cashfree.com/partner-ui/authentication/login?source-action=partner%20signin&action=Sign%20in&button-id=StartIn_Navbar",
);
SignInHeaderMap.set(
  "about-us",
  "https://merchant.cashfree.com/merchants/login?source-action=About%20Us&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "payment-gateway-charges",
  "https://merchant.cashfree.com/merchant/login?source-action=Pricing%20Page&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "shopify-payment-gateway-india",
  "https://merchant.cashfree.com/merchants/login?source-action=Shopify%20Page&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "smart-sell-affordablity",
  "https://merchant.cashfree.com/merchant/login?source-action=SmartSell%20Affordablity&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "online-payment-gateway",
  "https://merchant.cashfree.com/merchants/login?source-action=Online%20Payment%20Gateway&action=Sign%20Up&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "freelancer-payment-gateway",
  "https://merchant.cashfree.com/merchants/login?source-action=Freelancer%20Payment%20Gateway&action=Sign%20Up&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "international-wire-transfer",
  "https://merchant.cashfree.com/merchants/login?source-action=international%20wire%20transfer&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "vendor-payments",
  "https://merchant.cashfree.com/merchants/login?source-action=Vendor%20Payments&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "debit-card-emi",
  "https://merchant.cashfree.com/merchants/login?source-action=Debit%20Card%20EMI&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "kyc-verification",
  "https://merchant.cashfree.com/merchants/login?source-action=Verification%20Suite&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "embedded-payments",
  "https://partner.cashfree.com/partner-ui/authentication/login?source-action=Embedded%20Payments&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "escrow-account",
  "https://merchant.cashfree.com/merchants/login?source-action=One%20Escrow&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "privacypolicy",
  "https://merchant.cashfree.com/merchants/login?source-action=Privacy%20Policy&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "paymentservices_tnc",
  "https://merchant.cashfree.com/merchants/login?source-action=Payment%20Services%20TnC&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "tnc",
  "https://merchant.cashfree.com/merchants/login?source-action=TnC&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "whitepapers/optimizing-transaction-success-rate",
  "https://merchant.cashfree.com/merchants/login?source-action=hsr%20ebook&action=Sign%20In&button-id=SignIn_Navbar",
);

SignInHeaderMap.set(
  "settlement-and-reconciliation-guide",
  "https://merchant.cashfree.com/merchants/login?source-action=Settlement%20Reconciliation%20Guide&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "preauthorization",
  "https://merchant.cashfree.com/merchants/login?source-action=Pre%20Auth&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "send-money-to-india/global-payouts",
  "https://merchant.cashfree.com/merchants/login?source-action=global%20payouts%20lp&action=Sign%20&In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "banking-as-a-service",
  "https://merchant.cashfree.com/merchants/login?source-action=banking%20as%20a%20service&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "auto-e-collect",
  "https://merchant.cashfree.com/merchant/login?source-action=Autocollect%20Page&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "woocommerce-payment-gateway-india",
  "https://merchant.cashfree.com/merchants/login?source-action=Woocommerce%20Page&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "instant-refunds",
  "https://merchant.cashfree.com/merchants/login?source-action=Instant%20Refund&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "magento-payment-gateway-india",
  "https://merchant.cashfree.com/merchants/login?source-action=Magento%20Page&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "kyc-link",
  "https://merchant.cashfree.com/merchants/login?source-action=kyc%20link&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "bbps-biller",
  "https://merchant.cashfree.com/merchants/login",
);
SignInHeaderMap.set(
  "cb-partner-solutions/global-trade-plaza",
  "https://merchant.cashfree.com/merchants/login?source-action=PartnerSolution%20CB%20GTP&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "accelerated-onboarding",
  "https://merchant.cashfree.com/merchants/login?source-action=accelerated%20onboarding&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "soft-pos",
  "https://merchant.cashfree.com/merchants/login?source-action=softpos&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "international-payment-gateway",
  "https://merchant.cashfree.com/merchants/login?source-action=International%20Payment%20Gateway&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "affiliate-program",
  "https://partner.cashfree.com/partner-ui/authentication/login?source-action=Affiliate%20Program&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "how-to-choose-the-right-payment-stack-for-optimal-subscription-management",
  "https://merchant.cashfree.com/merchants/login?source-action=Ebook%20Subscription%20Management&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "digilocker-api",
  "https://merchant.cashfree.com/merchants/login?source-action=DigiLocker%20API%20LP&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "face-match-api",
  "https://merchant.cashfree.com/merchants/login?source-action=Face%20Match%20API%20LP&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "driving-license-verification-api",
  "https://merchant.cashfree.com/merchants/login?source-action=DL%20Verification%20API%20LP&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "geolocation-api",
  "https://merchant.cashfree.com/merchants/login?source-action=GeoLocation%20API&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "aadhaar-esign",
  "https://merchant.cashfree.com/merchants/login?source-action=Aadhaar%20eSign&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "passport-verification-api",
  "https://merchant.cashfree.com/merchants/login?source-action=Passport%20Verification%20API&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "accept-international-payments",
  "https://merchant.cashfree.com/merchants/login?source-action=Accept%20International%20Payments&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "payment-gateway-india",
  "https://merchant.cashfree.com/merchant/login?source-action=PG%20Page&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "employee-background-verification",
  "https://merchant.cashfree.com/merchants/login?source-action=Employee%20Background%20Verification&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "zoho-payment-gateway",
  "https://merchant.cashfree.com/merchants/login?source-action=Zoho%20Integration&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "IFSC-verification-api",
  "https://merchant.cashfree.com/merchants/login?source-action=IFSC%20Verification%20API&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "gst-search-by-pan",
  "https://merchant.cashfree.com/merchants/login?source-action=GST%20Search%20by%20PAN&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "voter-id-verification",
  "https://merchant.cashfree.com/merchants/login?source-action=Voter%20ID%20Verification&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "customer-reward-scheme-terms-and-conditions",
  "https://merchant.cashfree.com/merchants/login?source-action=CustomerReward%20TnC&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "aadhaar-masking",
  "https://merchant.cashfree.com/merchants/login?source-action=Aadhaar%20Masking%20API&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "rc-verification",
  "https://merchant.cashfree.com/merchants/login?source-action=RC%20Verification%20API&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "aadhaar-ocr-verification",
  "https://merchant.cashfree.com/merchants/login?source-action=Aadhaar%20OCR%20Verification&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "digital-onboarding",
  "https://merchant.cashfree.com/merchants/login?source-action=Digital%20Onboarding&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "kyb-solutions",
  "https://merchant.cashfree.com/merchants/login?source-action=KYB%20Solutions%20LP&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "digital-kyc",
  "https://merchant.cashfree.com/merchants/login?source-action=Digital%20KYC&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "automated-kyc",
  "https://merchant.cashfree.com/merchants/login?source-action=Automated%20KYC&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "risk-shield-for-payment-disbursal",
  "https://merchant.cashfree.com/merchants/login?source-action=RiskShield%20Payouts&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "beneficiary-verification",
  "https://merchant.cashfree.com/merchants/login?source-action=Beneficiary%20Verification&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "risk-shield-payment-gateway",
  "https://merchant.cashfree.com/merchants/login?source-action=RiskShield%20PG&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "checkout-one",
  "https://merchant.cashfree.com/merchants/login?source-action=CheckOut%20One&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "news-room",
  "https://merchant.cashfree.com/merchants/login?source-action=News%20Room&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "d2c-payment-gateway",
  "https://merchant.cashfree.com/merchants/login?source-action=D2C%20PG&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "developer-code-of-conduct",
  "https://merchant.cashfree.com/merchants/login?source-action=Developer%20Code%20Conduct&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "prefill-api",
  "https://merchant.cashfree.com/merchants/login?source-action=Prefill%20API&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "kyc-studio",
  "https://merchant.cashfree.com/merchants/login?source-action=KYC%20Studio&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "payment-gateway",
  "https://merchant.cashfree.com/merchants/login?source-action=PG1%20Paid&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "one-click-checkout",
  "https://merchant.cashfree.com/merchants/login?source-action=OneClick%20festive%20Paid&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "upi-switch",
  "https://merchant.cashfree.com/merchants/login?source-action=UPI%20Switch&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "payment-pages",
  "https://merchant.cashfree.com/merchant/login?source-action=payment%20pages&action=Sign%20In&button-id=SignIn_Navbar",
);
SignInHeaderMap.set(
  "settlement-holidays",
  "https://merchant.cashfree.com/merchants/login?source-action=Settlement%20Holidays&action=Sign%20In&button-id=SignIn_Navbar",
);
export default SignInHeaderMap;
